import React, { forwardRef, memo } from 'react';
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import KanbanColumn from './KanbanColumn';
import SortableColumn from './SortableColumn';

/**
 * KanbanBoard - Standard columns mode (non-swimlane)
 */
const KanbanBoard = memo(forwardRef(({
  columns,
  columnIds,
  tasksByStatus,
  taskIdsByColumn,
  selectedTaskIds,
  collapsedColumns,
  expandingColumns,
  editingColumnId,
  activeColumnId,
  activeCardId,
  frozenTaskCounts,
  frozenHiddenCounts,
  visibleCardCount,
  cardHandlerProps,
  onToggleCollapse,
  onAddTask,
  onAddDecision,
  onAddWait,
  onColumnNameSave,
  onDeleteColumn,
  onAddStatus,
  onReassignTasksStatus,
  onSetWipLimit,
  onBoardClick,
  onBoardWheel,
}, ref) => {
  const boardClasses = [
    'kanban-board',
    activeColumnId && 'kanban-board--column-dragging',
    activeCardId && 'kanban-board--card-dragging',
  ].filter(Boolean).join(' ');

  return (
    <SortableContext items={columnIds} strategy={horizontalListSortingStrategy}>
      <div 
        ref={ref}
        className={boardClasses}
        onClick={onBoardClick}
        onWheel={onBoardWheel}
      >
        {columns.map(column => (
          <SortableColumn key={column.id} id={column.id} disabled={false}>
            <KanbanColumn
              column={column}
              tasks={tasksByStatus[column.id] || []}
              taskIds={taskIdsByColumn[column.id] || []}
              selectedTaskIds={selectedTaskIds}
              isCollapsed={collapsedColumns.has(column.id)}
              isExpanding={expandingColumns.has(column.id)}
              isEditingName={editingColumnId === column.id}
              activeCardId={activeCardId}
              onToggleCollapse={onToggleCollapse}
              onAddTask={onAddTask}
              onAddDecision={onAddDecision}
              onAddWait={onAddWait}
              onColumnNameSave={onColumnNameSave}
              onDeleteColumn={onDeleteColumn}
              onAddStatus={onAddStatus}
              onReassignTasksStatus={onReassignTasksStatus}
              onSetWipLimit={onSetWipLimit}
              isAnyColumnDragging={!!activeColumnId}
              isAnyCardDragging={!!activeCardId}
              frozenTaskCount={frozenTaskCounts?.[column.id]}
              frozenHiddenCount={frozenHiddenCounts?.[column.id]}
              visibleCardCount={visibleCardCount}
              {...cardHandlerProps}
            />
          </SortableColumn>
        ))}
      </div>
    </SortableContext>
  );
}));

export default KanbanBoard;

